import React, { Component } from 'react';
import { connect } from 'react-redux';
import Loader from 'react-loader';
import { getFormValues } from 'redux-form';
import {
  Button,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from 'reactstrap';
import Layout from '../components/Layout';
import PageNav from '../components/PageNav';
import ArticleForm from '../modules/ArticleForm';
import { fetchArticleDetail } from '../modules/ArticleDetail/actions';
import { isLoaded, getError } from '../modules/ArticleDetail/selectors';
import { deleteArticle } from '../modules/ArticleList/actions';
import { ARTICLE_FORM_NAME } from '../modules/ArticleForm/constants';

class EditArticlePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false
    };

    this.toggle = this.toggle.bind(this);
  }

  componentDidMount() {
    const { id, lang } = this.props.match.params;
    this.props.fetchArticleDetail(id, lang);
  }

  toggle() {
    this.setState({
      modal: !this.state.modal
    });
  }

  deleteArticle = () => {
    const { id, lang } = this.props.match.params;
    this.props.deleteArticle(id, lang, () => {
      this.toggle();
      this.props.history.push('/clanky');
    });
  };

  getConfig = () => {
    const { state } = this.props.location;
    if (!state) {
      return undefined;
    } else {
      return state;
    }
  };

  render() {
    const { isLoaded, articleInitialValues, match } = this.props;
    const { lang } = match.params;

    const initialValues = { ...articleInitialValues, lang };

    return (
      <Layout>
        <Container>
          <Loader loaded={isLoaded}>
            <PageNav>
              <h1>Upravit článek</h1>
              <Button onClick={this.toggle} color="danger">
                Smazat tuto mutaci
              </Button>
            </PageNav>
            <ArticleForm
              config={this.getConfig()}
              initialValues={initialValues}
            />
            <Modal
              isOpen={this.state.modal}
              toggle={this.toggle}
              className={this.props.className}
              backdrop={this.state.backdrop}
            >
              <ModalHeader toggle={this.toggle}>Smazat</ModalHeader>
              <ModalBody>Opravdu chcete tuto mutaci článku smazat?</ModalBody>
              <ModalFooter>
                <Button color="danger" onClick={this.deleteArticle}>
                  Smazat
                </Button>{' '}
                <Button color="secondary" onClick={this.toggle}>
                  Zrušit
                </Button>
              </ModalFooter>
            </Modal>
          </Loader>
        </Container>
      </Layout>
    );
  }
}

const mapStateToProps = state => {
  return {
    articleInitialValues: getFormValues(ARTICLE_FORM_NAME)(state),
    isLoaded: isLoaded(state),
    error: getError(state)
  };
};

export default connect(
  mapStateToProps,
  { fetchArticleDetail, deleteArticle }
)(EditArticlePage);



// WEBPACK FOOTER //
// ./src/pages/EditArticlePage.js